var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id },
    },
    [
      _c(
        "a",
        {
          staticClass: "product-link",
          attrs: { href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId) },
        },
        [
          _c("div", { staticClass: "thumb-title" }, [
            _vm._v(
              "\n      " + _vm._s(_vm._f("itemName")(_vm.item)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex d-lg-block px-2 flex-md-wrap" },
            [
              _c(
                "div",
                { staticClass: "thumb-image" },
                [
                  Object.keys(_vm.storeSpecialExtra).length > 0
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "storespecialextra d-none d-lg-block",
                            style: {
                              "background-color":
                                _vm.storeSpecialExtra.background,
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "d-flex",
                                style: {
                                  color: _vm.storeSpecialExtra.textColor,
                                },
                                attrs: { href: _vm.storeSpecialExtra.url },
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-info",
                                  style: {
                                    "background-color":
                                      _vm.storeSpecialExtra.background,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "storespecialextra-text" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.storeSpecialExtra.text) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("lazy-img", {
                    staticClass: "img-fluid",
                    attrs: {
                      "image-url": _vm.itemNoPicImage,
                      alt: _vm._f("itemName")(_vm.item),
                      title: _vm._f("itemName")(_vm.item),
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm._t("store-special", function () {
                return [
                  _vm.storeSpecial
                    ? _c("item-store-special", {
                        attrs: {
                          "store-special": _vm.storeSpecial,
                          "recommended-retail-price": _vm.item.prices.rrp,
                          "variation-retail-price": _vm.item.prices.default,
                          "special-offer-price": _vm.item.prices.specialOffer,
                          "decimal-count": _vm.decimalCount,
                          "item-type": _vm.item.item.itemType,
                        },
                      })
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _vm._t("item-details", function () {
                return [
                  _c(
                    "div",
                    { staticClass: "thumb-content" },
                    [
                      _c("div", { staticClass: "product-more" }, [
                        _c(
                          "ul",
                          { staticClass: "product-details" },
                          [
                            Object.keys(_vm.storeSpecialExtra).length > 0
                              ? [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "d-block d-lg-none",
                                      style: {
                                        "background-color":
                                          _vm.storeSpecialExtra.background,
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "d-flex",
                                          style: {
                                            color:
                                              _vm.storeSpecialExtra.textColor,
                                          },
                                          attrs: {
                                            href: _vm.storeSpecialExtra.url,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-info",
                                            style: {
                                              "background-color":
                                                _vm.storeSpecialExtra
                                                  .background,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-flex align-items-center text",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.storeSpecialExtra.text
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.stock.net > 0
                              ? _c(
                                  "li",
                                  {
                                    directives: [
                                      { name: "tooltip", rawName: "v-tooltip" },
                                    ],
                                    attrs: {
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title:
                                        "Aktueller Lagerbestand: " +
                                        _vm.item.stock.net,
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "icon-box" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(_vm._s(_vm.item.stock.net) + " "),
                                      _c("span", { staticClass: "d-md-none" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Servershop5::Template.sofortlieferbar"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.variation.availability.id == 1
                              ? _c(
                                  "li",
                                  {
                                    directives: [
                                      { name: "tooltip", rawName: "v-tooltip" },
                                    ],
                                    attrs: {
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title:
                                        _vm.item.variation.availability.names
                                          .name,
                                    },
                                  },
                                  [
                                    _c("lazy-img", {
                                      staticClass: "product-details__img",
                                      attrs: {
                                        "image-url":
                                          "https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/deliverable1-2.svg",
                                        alt: "deliverable 1-2",
                                        title: "deliverable 1-2",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text d-md-none" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.item.variation.availability
                                              .names.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.variation.availability.id == 2
                              ? _c(
                                  "li",
                                  {
                                    directives: [
                                      { name: "tooltip", rawName: "v-tooltip" },
                                    ],
                                    attrs: {
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title:
                                        _vm.item.variation.availability.names
                                          .name,
                                    },
                                  },
                                  [
                                    _c("lazy-img", {
                                      staticClass: "product-details__img",
                                      attrs: {
                                        "image-url":
                                          "https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/deliverable1-3.svg",
                                        alt: "deliverable 1-3",
                                        title: "deliverable 1-3",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text d-md-none" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.item.variation.availability
                                              .names.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.variation.availability.id == 3
                              ? _c(
                                  "li",
                                  {
                                    directives: [
                                      { name: "tooltip", rawName: "v-tooltip" },
                                    ],
                                    attrs: {
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title:
                                        _vm.item.variation.availability.names
                                          .name,
                                    },
                                  },
                                  [
                                    _c("lazy-img", {
                                      staticClass: "product-details__img",
                                      attrs: {
                                        "image-url":
                                          "https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/deliverable3-7.svg",
                                        alt: "deliverable 3-7",
                                        title: "deliverable 3-7",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text d-md-none" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.item.variation.availability
                                              .names.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.variation.availability.id == 4 ||
                            _vm.item.variation.availability.id == 5
                              ? _c(
                                  "li",
                                  {
                                    directives: [
                                      { name: "tooltip", rawName: "v-tooltip" },
                                    ],
                                    attrs: {
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title:
                                        _vm.item.variation.availability.names
                                          .name,
                                    },
                                  },
                                  [
                                    _c("lazy-img", {
                                      staticClass: "product-details__img",
                                      attrs: {
                                        "image-url":
                                          "https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/undeliverable.svg",
                                        alt: "undeliverable",
                                        title: "undeliverable",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text d-md-none" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.item.variation.availability
                                              .names.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.variation.availability.id == 6
                              ? _c(
                                  "li",
                                  {
                                    directives: [
                                      { name: "tooltip", rawName: "v-tooltip" },
                                    ],
                                    attrs: {
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title:
                                        _vm.item.variation.availability.names
                                          .name,
                                    },
                                  },
                                  [
                                    _c("lazy-img", {
                                      staticClass: "product-details__img",
                                      attrs: {
                                        "image-url":
                                          "https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/request.svg",
                                        alt: "request",
                                        title: "request",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text d-md-none" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.item.variation.availability
                                              .names.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.item.item.free16 &&
                              _vm.item.item.free16 != 0) ||
                            (_vm.item.item.free17 && _vm.item.item.free17 != 0)
                              ? _c(
                                  "li",
                                  {
                                    directives: [
                                      { name: "tooltip", rawName: "v-tooltip" },
                                    ],
                                    attrs: {
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title:
                                        "Für dieses Gerät sind Upgrades verfügbar",
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "icon-settings" }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text d-md-none" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Servershop5::Template.upgradesAvailable"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "thumb-meta mt-2" },
                        [
                          _vm._t("before-prices"),
                          _vm._v(" "),
                          _vm.showPrice
                            ? _c(
                                "div",
                                {
                                  staticClass: "prices justify-content-center",
                                },
                                [
                                  _vm.item.prices.rrp &&
                                  _vm.item.prices.rrp.price.value > 0 &&
                                  _vm.item.prices.rrp.price.value >
                                    _vm.item.prices.default.unitPrice.value
                                    ? _c(
                                        "div",
                                        { staticClass: "price-view-port" },
                                        [
                                          _vm.item.prices.specialOffer
                                            ? _c(
                                                "del",
                                                { staticClass: "crossprice" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "itemCrossPrice"
                                                        )(
                                                          _vm.item.prices
                                                            .default.unitPrice
                                                            .formatted,
                                                          true
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "del",
                                                { staticClass: "crossprice" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "itemCrossPrice"
                                                        )(
                                                          _vm.item.prices.rrp
                                                            .unitPrice.formatted
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "price" },
                                    [
                                      _vm.item.item.itemType === "set"
                                        ? [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.itemSetPrice",
                                                    { price: _vm.itemSetPrice }
                                                  )
                                                ) +
                                                " *\n                "
                                            ),
                                          ]
                                        : !!_vm.item.item &&
                                          _vm.item.item.salableVariationCount >
                                            1 &&
                                          _vm.$ceres.isCheapestSorting
                                        ? [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.categoryItemFromPrice",
                                                    { price: _vm.itemPrice }
                                                  )
                                                ) +
                                                " *\n                "
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm._f("specialOffer")(
                                                    _vm.item.prices.default
                                                      .unitPrice.formatted,
                                                    _vm.item.prices,
                                                    "unitPrice",
                                                    "formatted"
                                                  )
                                                ) +
                                                " *\n                "
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t("after-prices"),
                      _vm._v(" "),
                      !(
                        _vm.item.unit.unitOfMeasurement === "C62" &&
                        _vm.item.unit.content === 1
                      )
                        ? _c(
                            "div",
                            { staticClass: "category-unit-price small" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.item.unit.content)),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.item.unit.names.name)),
                              ]),
                              _vm._v(" "),
                              _vm.item.variation.mayShowUnitPrice
                                ? _c("span", [
                                    _vm._v(
                                      " | " +
                                        _vm._s(
                                          _vm.item.prices.default.basePrice
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }